<template>
  <a-modal :width="800" centered :footer="null" @cancel="$emit('close')" :visible="visible" title="用户活跃度详情">
    <ul class="top">
      <li class="top-item">
        <div class="circle">
          <img src="@/assets/workbench/date.png" alt="" />
        </div>
        <div class="right">
          <p>2022-05-23</p>
          <span>日期</span>
        </div>
      </li>
      <li class="top-item">
        <div class="circle">
          <img src="@/assets/workbench/user.png" alt="" />
        </div>
        <div class="right">
          <p>24</p>
          <span>用户数量</span>
        </div>
      </li>
      <li class="top-item">
        <div class="circle">
          <img src="@/assets/workbench/clock.png" alt="" />
        </div>
        <div class="right">
          <p>7.5h</p>
          <span>平均停留时长</span>
        </div>
      </li>
    </ul>
    <a-table class="active-info" :columns="columns" :dataSource="datas" :pagination="pagination"></a-table>
  </a-modal>
</template>
<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      columns: [
        {
          title: '用户ID',
          dataIndex: 'userId'
        },
        {
          title: '所属公司',
          dataIndex: 'company'
        },
        {
          title: '停留时长',
          dataIndex: 'stayTime'
        }
      ],
      pagination: {
        pageNumber: 1,
        pageSize: 10,
        total: 28
      },
      datas: [
        {
          key: 1,
          userId: 'id134939r8848',
          company: '上海科技股份有限公司名称示例',
          stayTime: '6h'
        },
        {
          key: 2,
          userId: 'id134939r8848',
          company: '上海科技股份有限公司名称示例上海科技股份',
          stayTime: '5.5h'
        },
        {
          key: 3,
          userId: 'id134939r8848',
          company: '上海科技股份有限公司名称示例',
          stayTime: '6h'
        },
        {
          key: 4,
          userId: 'id134939r8848',
          company: '上海科技股份有限公司名称示例上海科技股份',
          stayTime: '5.5h'
        }
      ]
    }
  }
}
</script>
<style lang="less">
.top {
  overflow: hidden;
  padding: 0;
  margin: 0;
  padding: 0 26px;
  margin-bottom: 30px;
  .top-item {
    list-style: none;
    float: left;
    width: 33.3%;
    .circle {
      width: 57px;
      height: 57px;
      background-color: #e9f5ff;
      margin-right: 16px;
      border-radius: 50%;
      line-height: 52px;
      text-align: center;
      float: left;
      img {
        width: 28px;
        height: 25px;
      }
    }
    .right {
      p {
        color: #333;
        font-size: 22px;
        margin-bottom: 0;
      }
      span {
        color: #999999;
        font-size: 12px;
      }
    }
  }
}
.active-info {
  th {
    padding: 9px 16px !important;
    font-size: 12px;
    color: #060a1a !important;
  }
}
</style>
